// extracted by mini-css-extract-plugin
export default {"container":"WelcomePage_container__II4Y0","center":"WelcomePage_center__eN4mk","wrapper":"WelcomePage_wrapper__FZwtu"};